module.exports = __webpack_public_path__ + "assets/img/791587017422_.pic_hd.9eb7c614.jpg";